{
  "CONTACT_PANEL": {
    "NOT_AVAILABLE": "NIe je k dispozícii",
    "EMAIL_ADDRESS": "E-mailová adresa",
    "PHONE_NUMBER": "Telefónne číslo",
    "IDENTIFIER": "Identifikátor",
    "COPY_SUCCESSFUL": "Úspešne nakopírované",
    "COMPANY": "Spoločnosť",
    "LOCATION": "Lokácia",
    "BROWSER_LANGUAGE": "Jazyk prehliadača",
    "CONVERSATION_TITLE": "Detaily konverzácie",
    "VIEW_PROFILE": "Ukáž profil",
    "BROWSER": "Prehliadač",
    "OS": "Operačný systém",
    "INITIATED_FROM": "Iniciované z",
    "INITIATED_AT": "Iniciované o",
    "IP_ADDRESS": "IP adresa",
    "CREATED_AT_LABEL": "Vytvorené",
    "NEW_MESSAGE": "Nová správa",
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "K tomuto kontaktu nie sú priradené žiadne predchádzajúce konverzácie.",
      "TITLE": "Prechádzajúce konverzácie"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Označenia kontaktov",
        "ERROR": "Nebolo možné aktualizovať označenia"
      },
      "CONVERSATION": {
        "TITLE": "Označenia konverzácii",
        "ADD_BUTTON": "Pridaj označenia"
      },
      "LABEL_SELECT": {
        "TITLE": "Pridaj označenia",
        "PLACEHOLDER": "Hľadaj označenia",
        "NO_RESULT": "Žiadne označenia neboli nájdené",
        "CREATE_LABEL": "Vytvoriť nový štítok"
      }
    },
    "MERGE_CONTACT": "Zlúčiť kontakt",
    "CONTACT_ACTIONS": "Akcie kontaktov",
    "MUTE_CONTACT": "Zablokovať kontakt",
    "UNMUTE_CONTACT": "Odblokovať kontakt",
    "MUTED_SUCCESS": "Tento kontakt bol úspešne zablokovaný. Jeho konverzácie budú čoskoro vyriešené na pozadí.",
    "UNMUTED_SUCCESS": "Tento kontakt bol úspešne odblokovaný.",
    "SEND_TRANSCRIPT": "Odoslať prepis",
    "EDIT_LABEL": "Upraviť",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Vlastné atribúty",
      "CONTACT_LABELS": "Označenia kontaktov",
      "PREVIOUS_CONVERSATIONS": "Prechádzajúce konverzácie",
      "NO_RECORDS_FOUND": "Žiadne atribúty neboli nájdené"
    },
    "CONFIRM": {
      "YES": "OK",
      "CANCEL": "Zrušiť"
    },
    "WHATSAPP_USERNAME": "Používateľské meno WhatsApp",
    "COPY_NAME": "Kopírovať meno",
    "COPY_REFERER": "Kopírovať URL",
    "LTV": "LTV",
    "CONVERSATION_LANGUAGE": "Jazyk konverzácie",
    "MUTE_CONTACT_DISABLED": "Nie je možné použiť. Celá doména kontaktu je blokovaná.",
    "BLOCK_CONTACT_DOMAIN": "Blokovať doménu kontaktu",
    "UNBLOCK_CONTACT_DOMAIN": "Odblokovať doménu kontaktu",
    "BLOCK_CONTACT_DOMAIN_DISABLED": "Túto doménu kontaktu nie je možné blokovať.",
    "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blokovanie domény zablokuje všetky existujúce a budúce kontakty pre túto doménu.",
    "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Odblokovanie domény odstráni blokovanie zo všetkých kontaktov pre túto doménu (vrátane tých, ktoré boli manuálne zablokované).",
    "BLOCK_PUBLIC_DOMAIN_TITLE": "Verejná e-mailová doména",
    "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} je verejná e-mailová doména, ktorú používa veľa nesúvisiacich odosielateľov, preto ju nemožno zablokovať celú. Chcete zablokovať len túto adresu ({email})?",
    "BLOCK_ONLY_THIS_ADDRESS": "Blokovať len túto adresu",
    "OPEN_JARABOT": "Otvoriť históriu AI odpovedí",
    "TRANSLATE_CONVERSATION": "Preložiť konverzáciu",
    "TRANSLATE_INITIATED": "Preklad bol spustený. Pri dlhších konverzáciách to môže chvíľu trvať.",
    "TRANSLATE_SUCCESS": "Preklad konverzácie bol úspešne dokončený.",
    "TRANSLATE_ERROR": "Nepodarilo sa preložiť konverzáciu. Skúste to prosím znova.",
    "MOVE_CONVERSATION": "Presunúť konverzáciu",
    "MOVE_CONVERSATION_MISSING_EMAIL": "E-mail kontaktu je povinný pre presun konverzácie do e-mailovej schránky",
    "MERGE_CONVERSATION": "Zlúčiť konverzáciu",
    "CONTACT_DOMAIN_BLOCKED_SUCCESS": "Táto doména bola úspešne zablokovaná. Nebudete upozornení na žiadne budúce konverzácie.",
    "CONTACT_DOMAIN_UNBLOCKED_SUCCESS": "Táto doména bola úspešne odblokovaná."
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Upraviť kontakt",
    "TITLE": "Upraviť kontakt",
    "DESC": "Upraviť kontaktné detaily"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Vymazať kontakt",
    "TITLE": "Vymazať kontakt",
    "DESC": "Odstrániť kontaktné údaje",
    "CONFIRM": {
      "TITLE": "Potvrdiť vymazanie",
      "MESSAGE": "Určite chcete vymazať ",
      "YES": "Áno, vymazať",
      "NO": "Nie, ponechať"
    },
    "API": {
      "SUCCESS_MESSAGE": "Kontakt úspešne odstránený",
      "ERROR_MESSAGE": "Nepodarilo sa vymazať kontakt. Skúste to prosím neskôr."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Uložiť",
      "CANCEL": "Zrušiť",
      "AVATAR": {
        "LABEL": "Fotka kontaktu"
      },
      "NAME": {
        "PLACEHOLDER": "Zadajte celé meno kontaktu",
        "LABEL": "Celé meno"
      },
      "BIO": {
        "PLACEHOLDER": "Zadajte info o kontakte",
        "LABEL": "Info"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "Zadajte e-mailovú adresu kontaktu",
        "LABEL": "E-mailová adresa",
        "DUPLICATE": "Táto e-mailová adresa sa používa pre iný kontakt.",
        "ERROR": "Prosím zadajte platnú e-mailovú adresu."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "Zadajte telefónne číslo kontaktu",
        "LABEL": "Telefónne číslo",
        "HELP": "Telefónne číslo musí byť vo formáte E.164, napr. +1415555555 [+][kód krajiny][predvoľba][miestne telefónne číslo]. Predvoľbu krajiny môžete vybrať zo zoznamu.",
        "ERROR": "Telefónne číslo by malo byť prázdne alebo vo formáte E.164",
        "DIAL_CODE_ERROR": "Vyberte predvoľbu krajiny zo zoznamu",
        "DUPLICATE": "Toto telefónne číslo sa používa pre iný kontakt."
      },
      "LOCATION": {
        "PLACEHOLDER": "Zadajte adresu kontaktu",
        "LABEL": "Lokácia"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Zadajte názov spoločnosti",
        "LABEL": "Názov spoločnosti"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Zadajte názov krajiny",
        "LABEL": "Názov krajiny",
        "SELECT_PLACEHOLDER": "Vybrať",
        "REMOVE": "Odstrániť",
        "SELECT_COUNTRY": "Vyberte krajinu"
      },
      "CITY": {
        "PLACEHOLDER": "Zadajte názov mesta",
        "LABEL": "Názov mesta"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Zadajte používateľské meno na Facebooku",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Zadajte používateľské meno na Twitteri",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Zadajte používateľské meno na LinkedIn",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Zadajte používateľské meno na Githube",
          "LABEL": "Github"
        }
      },
      "UNSAVED_CHANGES": {
        "TITLE": "Neuložené zmeny",
        "DESCRIPTION": "Máte neuložené zmeny. Chcete ich pred zatvorením uložiť?",
        "CONFIRM": "Uložiť",
        "CANCEL": "Zahodiť"
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Avatar kontaktu bol úspešne odstránený",
        "ERROR_MESSAGE": "Nepodarilo sa odstrániť avatar kontaktu. Skúste to prosím neskôr."
      }
    },
    "SUCCESS_MESSAGE": "Kontakt bol úspešne uložený",
    "ERROR_MESSAGE": "Vyskytla sa chyba, skúste to prosím znova"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Začať konverzáciu",
    "TITLE": "Nová konverzácia",
    "DESC": "Začnite novú konverzáciu odoslaním novej správy.",
    "NO_INBOX": "Nepodarilo sa nájsť schránku na začatie novej konverzácie s týmto kontaktom.",
    "FORM": {
      "TO": {
        "LABEL": "Pre"
      },
      "INBOX": {
        "LABEL": "",
        "PLACEHOLDER": "Vyberte zdrojovú schránku",
        "ERROR": "Vybrať schránku"
      },
      "SUBJECT": {
        "LABEL": "Predmet",
        "PLACEHOLDER": "Predmet",
        "ERROR": "Predmet nemôže byť prázdny"
      },
      "MESSAGE": {
        "LABEL": "Správa",
        "PLACEHOLDER": "Napíšte svoju správu sem",
        "ERROR": "Správa nemôže byť prázdna"
      },
      "ATTACHMENTS": {
        "SELECT": "Vybrať súbory",
        "HELP_TEXT": "Presuňte súbory sem alebo vyberte súbory na priloženie"
      },
      "SUBMIT": "Poslať správu",
      "CANCEL": "Zrušiť",
      "SUCCESS_MESSAGE": "Správa poslaná!",
      "GO_TO_CONVERSATION": "Zobraziť",
      "ERROR_MESSAGE": "Nepodarilo sa odoslať! Skúste to znova"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Sociálne profily"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Pridať vlastné atribúty",
    "COPY_SUCCESSFUL": "Úspešne nakopírované",
    "SHOW_MORE": "Zobraz všetky atribúty",
    "SHOW_LESS": "Zobraziť menej atribútov",
    "ACTIONS": {
      "COPY": "Kopírovať atribút",
      "DELETE": "Vymazaž atribút",
      "EDIT": "Upraviť atribút"
    },
    "ADD": {
      "TITLE": "Vytvoriť vlastný atribút",
      "DESC": "Pridanie vlastných informácií k tomuto kontaktu."
    },
    "FORM": {
      "CREATE": "Pridať atribút",
      "CANCEL": "Zrušiť",
      "NAME": {
        "LABEL": "Vlastný názov atribútu",
        "PLACEHOLDER": "Napr.: shopify id",
        "ERROR": "Nesprávny názov vlastného atribútu"
      },
      "VALUE": {
        "LABEL": "Hodnota atribútu",
        "PLACEHOLDER": "Napr.: 11901 "
      },
      "ADD": {
        "TITLE": "Vytvoriť nový atribút ",
        "SUCCESS": "Nový atribút úspešne pridaný",
        "ERROR": "Nebolo možné pridať atribút. Skúste to prosím neskôr"
      },
      "UPDATE": {
        "SUCCESS": "Atribút úspešne nahraný",
        "ERROR": "Nie je možné aktualizovať atribút. Skúste to prosím neskôr"
      },
      "DELETE": {
        "SUCCESS": "Aitribút úspešne vymazaný",
        "ERROR": "Nie je možné odstrániť atribút. Skúste to prosím neskôr"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Pridať atribúty",
        "PLACEHOLDER": "Hľadať atribúty",
        "NO_RESULT": "Žiadne atribúty neboli nájdené"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Vybrať hodnotu",
          "SEARCH_INPUT_PLACEHOLDER": "Vyhľadať hodnotu",
          "NO_RESULT": "Žiadne výsledky neboli nájdené"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Vyžaduje sa platná hodnota",
      "INVALID_URL": "Neplatná URL",
      "INVALID_INPUT": "Neplatný vstup"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Zlúčiť kontakty",
    "DESCRIPTION": "Zlúčením kontaktov spojíte dva profily do jedného vrátane všetkých atribútov a konverzácií. V prípade konfliktu budú mať prednosť atribúty primárneho kontaktu.",
    "PRIMARY": {
      "TITLE": "Primárny kontakt",
      "HELP_LABEL": "Na vymazanie"
    },
    "PARENT": {
      "TITLE": "Kontakt na zlúčenie",
      "PLACEHOLDER": "Hľadať kontakt",
      "HELP_LABEL": "Na uchovanie"
    },
    "SUMMARY": {
      "TITLE": "Sumár",
      "DELETE_WARNING": "Kontakt <strong>{primaryContactName}</strong> bude vymazaný.",
      "ATTRIBUTE_WARNING": "Kontaktné údaje <strong>{primaryContactName}</strong> budú skopírované do <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Niečo sa pokazilo. Skúste to prosím neskôr."
    },
    "FORM": {
      "SUBMIT": " Zlúčiť kontakty",
      "CANCEL": "Zrušiť",
      "CHILD_CONTACT": {
        "ERROR": "Vyberte kontakt, ktorý chcete zlúčiť"
      },
      "SUCCESS_MESSAGE": "Kontakt úspešne zlúčený",
      "ERROR_MESSAGE": "Nepodarilo sa zlúčiť kontakty, skúste to znova!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Kontakty",
      "SEARCH_TITLE": "Hľadať kontakty",
      "SEARCH_PLACEHOLDER": "Hľadať...",
      "MESSAGE_BUTTON": "Správa",
      "SEND_MESSAGE": "Poslať správu",
      "SHOW_DETAILS": "Podrobnosti kontaktu",
      "BLOCK_CONTACT": "Zablokovať kontakt",
      "UNBLOCK_CONTACT": "Odblokovať kontakt",
      "BREADCRUMB": {
        "CONTACTS": "Kontakty"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Pridať kontakt",
          "EXPORT_CONTACT": "Exportovať kontakty",
          "IMPORT_CONTACT": "Importovať kontakty",
          "SAVE_CONTACT": "Uložiť kontakt",
          "EMAIL_ADDRESS_DUPLICATE": "Táto e-mailová adresa sa používa pre iný kontakt.",
          "PHONE_NUMBER_DUPLICATE": "Toto telefónne číslo sa používa pre iný kontakt.",
          "SUCCESS_MESSAGE": "Kontakt bol úspešne uložený",
          "ERROR_MESSAGE": "Nepodarilo sa uložiť kontakt. Skúste to prosím neskôr."
        },
        "BLOCK_SUCCESS_MESSAGE": "Tento kontakt bol úspešne zablokovaný. Jeho konverzácie budú čoskoro vyriešené na pozadí.",
        "BLOCK_ERROR_MESSAGE": "Nepodarilo sa zablokovať kontakt. Skúste to prosím neskôr.",
        "UNBLOCK_SUCCESS_MESSAGE": "Tento kontakt bol úspešne odblokovaný",
        "UNBLOCK_ERROR_MESSAGE": "Nepodarilo sa odblokovať kontakt. Skúste to prosím neskôr.",
        "IMPORT_CONTACT": {
          "TITLE": "Importovať kontakty",
          "DESCRIPTION": "Importovať kontakty prostredníctvom súboru CSV.",
          "DOWNLOAD_LABEL": "Stiahnite si ukážkový CSV súbor.",
          "LABEL": "CSV súbor:",
          "CHOOSE_FILE": "Vybrať súbor",
          "CHANGE": "Zmeniť",
          "CANCEL": "Zrušiť",
          "IMPORT": "Importovať",
          "SUCCESS_MESSAGE": "Po dokončení importu vás upozorníme e-mailom.",
          "ERROR_MESSAGE": "Vyskytla sa chyba, skúste to prosím znova"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Exportovať kontakty",
          "DESCRIPTION": "Rýchlo exportujte súbor CSV s podrobnými údajmi o vašich kontaktoch",
          "CONFIRM": "Exportovať",
          "SUCCESS_MESSAGE": "Export is in progress, You will be notified via email when export file is ready to dowanlod.",
          "ERROR_MESSAGE": "Vyskytla sa chyba, skúste to prosím znova"
        },
        "SORT_BY": {
          "LABEL": "Zoradiť podľa",
          "OPTIONS": {
            "NAME": "Meno",
            "EMAIL": "E-mail",
            "PHONE_NUMBER": "Telefónne číslo",
            "COMPANY": "Spoločnosť",
            "COUNTRY": "Krajina",
            "CITY": "Mesto",
            "LAST_ACTIVITY": "Posledná aktivita",
            "CREATED_AT": "Vytvorené"
          }
        },
        "ORDER": {
          "LABEL": "Zoradenie",
          "OPTIONS": {
            "ASCENDING": "Vzostupne",
            "DESCENDING": "Zostupne"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "Chcete uložiť tento filter?",
            "CONFIRM": "Uložiť filter",
            "LABEL": "Meno",
            "PLACEHOLDER": "Zadajte názov filtra",
            "ERROR": "Zadajte platný názov",
            "SUCCESS_MESSAGE": "Filter bol úspešne uložený",
            "ERROR_MESSAGE": "Nepodarilo sa uložiť filter. Skúste to prosím neskôr."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Potvrdiť vymazanie",
            "DESCRIPTION": "Naozaj chcete odstrániť tento filter?",
            "CONFIRM": "Áno, vymazať",
            "CANCEL": "Nie, zrušiť",
            "SUCCESS_MESSAGE": "Filter bol úspešne odstránený",
            "ERROR_MESSAGE": "Nepodarilo sa odstrániť filter. Skúste to prosím neskôr."
          }
        }
      },
      "BLOCKING": "Blokovanie",
      "BLOCK_CONTACT_MESSAGE": "Zablokovanie tohto kontaktu mu zabráni vytvárať nové konverzácie a všetky jeho existujúce konverzácie budú vyriešené. Naozaj chcete zablokovať tento kontakt?",
      "UNBLOCK_CONTACT_MESSAGE": "Odblokovanie tohto kontaktu mu umožní vytvárať nové konverzácie. Naozaj chcete odblokovať tento kontakt?",
      "BLOCK_CONTACT_DISABLED": "Nie je možné použiť. Celá doména kontaktu je blokovaná.",
      "BLOCK_CONTACT_DOMAIN": "Blokovať doménu kontaktu",
      "UNBLOCK_CONTACT_DOMAIN": "Odblokovať doménu kontaktu",
      "BLOCK_CONTACT_DOMAIN_DISABLED": "Túto doménu kontaktu nie je možné blokovať.",
      "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blokovanie domény zablokuje všetky existujúce a budúce kontakty pre túto doménu.",
      "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Odblokovanie domény odstráni blokovanie zo všetkých kontaktov pre túto doménu (vrátane tých, ktoré boli manuálne zablokované).",
      "BLOCK_PUBLIC_DOMAIN_TITLE": "Verejná e-mailová doména",
      "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} je verejná e-mailová doména, ktorú používa veľa nesúvisiacich odosielateľov, preto ju nemožno zablokovať celú. Chcete zablokovať len tento kontakt ({email})?",
      "BLOCK_ONLY_THIS_CONTACT": "Blokovať len tento kontakt",
      "DIAL": "Vytočiť"
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Zobrazené {startItem} – {endItem} z {totalItems} kontaktov"
    },
    "FILTER": {
      "NAME": "Meno",
      "EMAIL": "E-mail",
      "PHONE_NUMBER": "Telefónne číslo",
      "IDENTIFIER": "Identifikátor",
      "COUNTRY": "Krajina",
      "CITY": "Mesto",
      "CREATED_AT": "Vytvorené",
      "LAST_ACTIVITY": "Posledná aktivita",
      "REFERER_LINK": "Odkaz na zdrojovú stránku",
      "BLOCKED": "Blokované",
      "BLOCKED_TRUE": "Áno",
      "BLOCKED_FALSE": "Nie",
      "BUTTONS": {
        "CLEAR_FILTERS": "Zrušiť filtre",
        "UPDATE_SEGMENT": "Aktualizovať segment",
        "APPLY_FILTERS": "Použiť filtre",
        "ADD_FILTER": "Pridať filter"
      },
      "TITLE": "Filtrovať kontakty",
      "EDIT_SEGMENT": "Upraviť segment",
      "SEGMENT": {
        "LABEL": "Názov segmentu",
        "INPUT_PLACEHOLDER": "Zadajte názov segmentu"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ ďalšie filtre: {count}",
        "CLEAR_FILTERS": "Zrušiť filtre"
      }
    },
    "CARD": {
      "OF": "z",
      "VIEW_DETAILS": "Ukáž detaily",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Upraviť kontaktné detaily",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Zadajte meno",
            "ERROR": "Meno je povinné."
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Zadajte priezvisko"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Zadajte e-mailovú adresu",
            "DUPLICATE": "Táto e-mailová adresa sa používa pre iný kontakt.",
            "ERROR": "Prosím zadajte platnú e-mailovú adresu."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Zadajte telefónne číslo",
            "DUPLICATE": "Toto telefónne číslo sa používa pre iný kontakt."
          },
          "CITY": {
            "PLACEHOLDER": "Zadajte názov mesta"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Vyberte krajinu"
          },
          "BIO": {
            "PLACEHOLDER": "Zadajte popis"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Zadajte názov spoločnosti"
          }
        },
        "UPDATE_BUTTON": "Aktualizovať kontakt",
        "SUCCESS_MESSAGE": "Kontakt bol úspešne aktualizovaný",
        "ERROR_MESSAGE": "Nepodarilo sa aktualizovať kontakt. Skúste to prosím neskôr."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Upraviť odkazy na sociálne siete",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Pridať Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "Pridať Github"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Pridať Instagram"
          },
          "WHATSAPP": {
            "PLACEHOLDER": "Pridať WhatsApp"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "Pridať LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "Pridať Twitter"
          }
        }
      }
    },
    "DETAILS": {
      "CREATED_AT": "Vytvorené {date}",
      "LAST_ACTIVITY": "Naposledy aktívny {date}",
      "DELETE_CONTACT_DESCRIPTION": "Natrvalo odstrániť tento kontakt. Túto akciu nie je možné vrátiť späť.",
      "DELETE_CONTACT": "Vymazať kontakt",
      "DELETE_DIALOG": {
        "TITLE": "Potvrdiť vymazanie",
        "DESCRIPTION": "Naozaj chcete odstrániť kontakt {contactName}?",
        "CONFIRM": "Áno, vymazať",
        "API": {
          "SUCCESS_MESSAGE": "Kontakt úspešne odstránený",
          "ERROR_MESSAGE": "Nepodarilo sa vymazať kontakt. Skúste to prosím neskôr."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Nepodarilo sa nahrať avatar. Skúste to prosím neskôr.",
          "SUCCESS_MESSAGE": "Avatar bol úspešne nahraný"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Avatar bol úspešne odstránený",
          "ERROR_MESSAGE": "Nepodarilo sa odstrániť avatar. Skúste to prosím neskôr."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Atribúty",
        "HISTORY": "History",
        "NOTES": "Poznámky",
        "MERGE": "Zlúčiť",
        "ORDER_HISTORY": "Nedávne objednávky",
        "RETINO": "Retino"
      },
      "HISTORY": {
        "EMPTY_STATE": "K tomuto kontaktu nie sú priradené žiadne predchádzajúce konverzácie"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Hľadať atribúty",
        "UNUSED_ATTRIBUTES": "Nepoužité atribúty: {count}",
        "EMPTY_STATE": "V tomto účte nie sú k dispozícii žiadne vlastné atribúty kontaktu. Vlastný atribút môžete vytvoriť v nastaveniach.",
        "YES": "Áno",
        "NO": "Nie",
        "TRIGGER": {
          "SELECT": "Vybrať hodnotu",
          "INPUT": "Zadajte hodnotu"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Neplatné číslo",
          "REQUIRED": "Vyžaduje sa platná hodnota",
          "INVALID_INPUT": "Neplatný vstup",
          "INVALID_URL": "Neplatná URL",
          "INVALID_DATE": "Neplatný dátum"
        },
        "NO_ATTRIBUTES": "Žiadne atribúty neboli nájdené",
        "API": {
          "SUCCESS_MESSAGE": "Atribút úspešne nahraný",
          "DELETE_SUCCESS_MESSAGE": "Aitribút úspešne vymazaný",
          "UPDATE_ERROR": "Nie je možné aktualizovať atribút. Skúste to prosím neskôr",
          "DELETE_ERROR": "Nie je možné odstrániť atribút. Skúste to prosím neskôr"
        }
      },
      "MERGE": {
        "TITLE": "Zlúčiť kontakt",
        "DESCRIPTION": "Zlúčte dva profily do jedného vrátane všetkých atribútov a konverzácií. Pri konflikte majú prednosť atribúty primárneho kontaktu.",
        "PRIMARY": "Primárny kontakt",
        "PRIMARY_HELP_LABEL": "Zostane zachovaný",
        "PRIMARY_REQUIRED_ERROR": "Pred pokračovaním vyberte kontakt na zlúčenie",
        "PARENT": "Bude zlúčený",
        "PARENT_HELP_LABEL": "Na vymazanie",
        "EMPTY_STATE": "Nenašli sa žiadne kontakty",
        "PLACEHOLDER": "Hľadať primárny kontakt",
        "SEARCH_PLACEHOLDER": "Hľadať kontakt",
        "SEARCH_ERROR_MESSAGE": "Nepodarilo sa vyhľadať kontakty. Skúste to prosím neskôr.",
        "SUCCESS_MESSAGE": "Kontakt úspešne zlúčený",
        "ERROR_MESSAGE": "Nepodarilo sa zlúčiť kontakty, skúste to znova!",
        "IS_SEARCHING": "Hľadá sa...",
        "BUTTONS": {
          "CANCEL": "Zrušiť",
          "CONFIRM": "Zlúčiť kontakt"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Pridať poznámku",
        "WROTE": "napísal(a)",
        "YOU": "Vy",
        "SAVE": "Uložiť poznámku",
        "EMPTY_STATE": "K tomuto kontaktu nie sú priradené žiadne poznámky. Poznámku pridáte napísaním do poľa vyššie."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "V tomto účte sa nenašli žiadne kontakty",
      "SUBTITLE": "Nové kontakty pridáte kliknutím na tlačidlo nižšie",
      "BUTTON_LABEL": "Pridať kontakt",
      "SEARCH_EMPTY_STATE_TITLE": "Žiadny kontakt nezodpovedá vášmu vyhľadávaniu 🔍",
      "LIST_EMPTY_STATE_TITLE": "V tomto zobrazení nie sú žiadne kontakty 📋"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "TITLE": "Nová konverzácia",
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "We couldn’t complete the search. Please try again."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "Zobraziť",
      "SUCCESS_MESSAGE": "Správa bola úspešne odoslaná!",
      "ERROR_MESSAGE": "Pri vytváraní konverzácie nastala chyba. Skúste to prosím neskôr.",
      "NO_INBOX_ALERT": "Nie sú k dispozícii žiadne schránky, cez ktoré by bolo možné začať konverzáciu s týmto kontaktom.",
      "CONTACT_SELECTOR": {
        "LABEL": "Pre:",
        "TAG_INPUT_PLACEHOLDER": "Hľadajte kontakt podľa mena, e-mailu alebo telefónneho čísla",
        "CONTACT_CREATING": "Vytvára sa kontakt..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Cez:",
        "BUTTON": "Zobraziť schránky"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Predmet :",
        "SUBJECT_PLACEHOLDER": "Sem zadajte predmet e-mailu",
        "CC_LABEL": "Kópia:",
        "CC_PLACEHOLDER": "Hľadajte kontakt podľa e-mailovej adresy",
        "BCC_LABEL": "Skrytá kópia:",
        "BCC_PLACEHOLDER": "Hľadajte kontakt podľa e-mailovej adresy",
        "BCC_BUTTON": "Skrytá kópia"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Napíšte svoju správu sem..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Vyberte šablónu",
        "SEARCH_PLACEHOLDER": "Hľadať šablóny",
        "EMPTY_STATE": "Nenašli sa žiadne šablóny",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "Šablóna WhatsApp: {templateName}",
          "VARIABLES": "Premenné",
          "BACK": "Späť",
          "SEND_MESSAGE": "Poslať správu"
        }
      },
      "ACTION_BUTTONS": {
        "DISCARD": "Discard",
        "SEND": "Odoslať ({keyCode})",
        "MARK_RESOLVED": "Označiť novú konverzáciu ako vyriešenú po odoslaní",
        "SAVE_DRAFT": "Uložiť koncept",
        "CREATE_AS_INTERNAL": "Vytvoriť ako konverzáciu s poznámkou",
        "SEND_AND_RESOLVE_ORIGINAL": "Odoslať a vyriešiť pôvodnú konverzáciu ({keyCode})"
      },
      "DISCARD": "Zahodiť koncept",
      "DISCARD_MODAL": {
        "TITLE": "Zahodiť koncept",
        "DESCRIPTION": "Naozaj chcete zahodiť tento koncept?",
        "CONFIRM": "Áno, zahodiť",
        "CANCEL": "Nie, ponechať"
      }
    }
  }
}
